import { FormControl, MenuItem, useTheme } from "@mui/material"
import { faHourglassStart } from "@fortawesome/pro-solid-svg-icons"
import {
  StyledChip,
  StyledChipSelect,
  StyledFontAwesomeIcon,
  StyledSelect
} from "components/ClpTable/components/actions/TableDropdown/TableDropdown.styled"
import {
  StatusDropdownProps,
  TableDropdownProps
} from "components/ClpTable/components/actions/TableDropdown/TableDropdown.interfaces"
import { useTranslation } from "react-i18next"

const TableDropdown = ({ initialValue, handleOnChange, options }: TableDropdownProps) => {
  return (
    <FormControl size="small">
      <StyledChipSelect
        onClick={(event) => event.stopPropagation()}
        initialValue={initialValue}
        autoWidth
        value={initialValue === null ? 0 : initialValue}
        onChange={handleOnChange}>
        {options.map((option, i: number) => (
          <MenuItem key={i} value={option.value}>
            {option.name}
          </MenuItem>
        ))}
      </StyledChipSelect>
    </FormControl>
  )
}

export const StatusDropdown = ({
  onChange,
  value,
  options,
  label,
  icon,
  color,
  iconSize,
  backgroundColor,
  iconColor
}: StatusDropdownProps) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const chipColor = color || theme.palette["info"].main

  return (
    <StyledSelect
      onClick={(event) => event.stopPropagation()}
      chipColor={chipColor}
      backgroundColor={backgroundColor}
      autoWidth
      value={value}
      onChange={onChange}
      renderValue={(value) => {
        return (
          <StyledChip
            chipColor={chipColor}
            backgroundColor={backgroundColor}
            icon={
              <StyledFontAwesomeIcon
                size={iconSize || "1x"}
                icon={icon || faHourglassStart}
                color={iconColor ? iconColor : chipColor}
              />
            }
            label={label ? label : t("learning.titles.not_started", "Not started")}
            sx={{ color: chipColor }}
            variant="outlined"
          />
        )
      }}>
      {options.map((option, i: number) => (
        <MenuItem key={i} value={option.value}>
          {option.name}
        </MenuItem>
      ))}
    </StyledSelect>
  )
}

export default TableDropdown
